/**
 * Ruta que no existe.
 *
 * Hace falta un componente propio porque con `_redirects` de Cloudflare Pages
 * **el CDN nunca devuelve 404**: cualquier path sirve `index.html`. Es lo que
 * necesita un router de historial, pero implica que el unico que puede decir
 * "esto no existe" es la SPA. Sin esta ruta, un typo en la URL muestra la
 * cascara con el contenido vacio, que parece una pantalla rota.
 */

import { Link, useLocation } from "react-router-dom";

import { SECTIONS } from "./routes";

export function NotFound() {
  const location = useLocation();

  return (
    <section className="screen notfound">
      <header className="screen__header">
        <h2>Esta pagina no existe</h2>
        <p className="screen__lead notfound__path">
          <code>{location.pathname}</code> no corresponde a ninguna seccion del panel.
        </p>
      </header>
      <p>
        Ir al <Link to={SECTIONS[0]?.path ?? "/"}>resumen</Link>, o elegir una seccion
        en el menu.
      </p>
    </section>
  );
}
